/** Plant imagery used across Our Plants (hero scatter, manufacturing, grinding carousel). */
export const OUR_PLANTS_PAGE_IMAGES = [
  '/images/plant_1.jpg',
  '/images/plant_2.png',
  '/images/plant_3.png',
] as const;

export function plantImageAt(index: number): (typeof OUR_PLANTS_PAGE_IMAGES)[number] {
  return OUR_PLANTS_PAGE_IMAGES[index % OUR_PLANTS_PAGE_IMAGES.length];
}
